export default "__VITE_ASSET__BVK3CQDS__"